import React from "react";
import { CGE } from "../../../../common/components/CGE";
import Loading from "../../../../common/components/Loading";
import { decode_utf8 ,validateEmailFunc} from "../../../../common/utils/utilsFunc";
import { useModal } from "@clayui/modal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import AlertModal from "../../../../common/components/AlertModal";
import useCookie from '../../../../common/hooks/useCookie';

const PersonalInfo = ({ props , state,ACTIONS, dispatch , setCurrentPage, form, setForm, setResetForm,optionsRegion,optionsComunaRegion,optionsPrefixCell}) => {
    const [loading, setLoading] = React.useState(false);
    const [valueCheckBoxSubscription, setValueCheckBoxSubscription] = React.useState(true);
    const [modalInfo, setModalInfo] = React.useState({});
    const [validForm, setValidForm] = React.useState({});
    const [visibleModal, setVisibleModal] = React.useState(false);
    const [visibleModalConfirm, setVisibleModalConfirm] = React.useState(false);
    const [checkPassword, setCheckPassword] = React.useState({})
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });

    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function validFormSecondPage() {

        let validForm = {};

        if (!form?.name) {
            validForm.validateName = true;
            validForm.msgName = "Debes ingresar el Nombre";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.firstName) {
            validForm.validateFirstName = true;
            validForm.msgFirstName = "Debes ingresar el Primer Apellido";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.secondName) {
            validForm.validateSecondName = true;
            validForm.msgSecondName = "Debes ingresar el Segundo Apellido";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.address) {
            validForm.validateAddress = true;
            validForm.msgAddress = "Debes ingresar la Dirección";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.addressNumber) {
            validForm.validateAddressNumber = true;
            validForm.msgAddressNumber = "Debes ingresar el Nro";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.region) {
            validForm.validateRegion = true;
            validForm.msgRegion = "Debes ingresar la Región";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.comuna) {
            validForm.validateComuna = true;
            validForm.msgComuna = "Debes ingresar la Comuna";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (form?.tel) {
            if (isNaN(form.tel)) {
                validForm.validateTel = true;
                validForm.msgTel = "Este campo no puede contener letras";
                props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
            } else if (form.tel.length !== 7 && form.tel.length !== 8) {
                validForm.validateTel = true;
                validForm.msgTel = "El número debe contener 7 o 8 dígitos";
                props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
            }
        }

        if (!form?.cel) {
            validForm.validateCel = true;
            validForm.msgCel = "El celular es obligatorio";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        } else if (isNaN(form.cel)) {
            validForm.validateCel = true;
            validForm.msgCel = "Este campo no puede contener letras";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        } else if (form.cel.length !== 9) {
            validForm.validateCel = true;
            validForm.msgCel = "El número debe contener 9 dígitos";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }


        if (!form?.email) {
            validForm.validateEmail = true;
            validForm.msgEmail = "Debes ingresar el E-mail";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        } else if (!validateEmailFunc(form?.email)) {
            validForm.validateEmail = true;
            validForm.msgEmail = "Debes ingresar un E-mail válido";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.emailConf) {
            validForm.validateEmailConf = true;
            validForm.msgEmailConf = "Debes ingresar el E-mail de confirmación";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        } else if (!validateEmailFunc(form?.emailConf)) {
            validForm.validateEmailConf = true;
            validForm.msgEmailConf = "Debes ingresar un E-mail de confirmación válido";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");

        } else if (form?.email !== form?.emailConf) {
            validForm.validateEmailConf = true;
            validForm.msgEmailConf = "Debes ingresar un E-mail de confirmación igual a E-mail";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.password) {
            validForm.validatePassword = true;
            validForm.msgPassword = "Debes ingresar la Contraseña de acceso";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        } else if (form?.password && (form?.password.length < 8)) {
            validForm.validatePassword = true;
            validForm.msgPassword = "Debes ingresar una Contraseña válida, debe contener como minimo 8 caracteres ";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.passwordConf) {
            validForm.validatePasswordConf = true;
            validForm.msgPasswordConf = "Debes ingresar una Contraseña de confirmación";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        } else if (form?.passwordConf && (form?.passwordConf.length < 8)) {
            validForm.validatePasswordConf = true;
            validForm.msgPasswordConf = "Debes ingresar una Contraseña de confirmación válida, debe contener como minimo 8 caracteres y igual a Contraseña de acceso ";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        } else if (checkPassword?.lowerCase !== true || checkPassword?.upperCase !== true || checkPassword?.containsNumber !== true || checkPassword?.minLength !== true) {
            validForm.validatePassword = true;
            validForm.msgPassword = "Debes ingresar una Contraseña válida.";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }else if (form?.password !== form?.passwordConf) {
            validForm.validatePasswordConf = true;
            validForm.msgPasswordConf = "Debes ingresar una contraseña de confirmación igual a contraseña";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }
        if(!verifReCaptcha) {
            validForm.validateVerifReCaptcha = true;
            props.setGlobalAlert("Falta validar que no eres un Robot.","warning");
        }

        setValidForm(validForm);
        return validForm;
    }

    function handleClickSecondPage() {
        const validForm = validFormSecondPage();

        if(Object.keys(validForm)?.length === 0) {
            setLoading(true);
            setVisibleModalConfirm(false)
            dispatch({
                type:ACTIONS.SET_FORM,
                payload:form
            })
        } else if(validForm === {}) {
            props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning", true, "Advertencia");
        }
    }

    React.useEffect(() => {
        if(state.formResponse){
            const objResponse = state.formResponse;
            setLoading(false);
            if(objResponse?.response?.status === 200 || objResponse?.data?.status === 200) {
                props.setGlobalAlert("¡Éxito en el registro de nuevo usuario! Enviamos un correo electrónico de confirmación a : "+objResponse?.data?.codeDeliveryDetails?.destination, "success", true, "Exito");
                setResetForm();
            } else if(objResponse?.response?.status === 500){

                props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning", true, "Advertencia");

            } else if(objResponse?.response?.status === 501){
                setVisibleModalConfirm(true);
            }else {
                props.setGlobalAlert(objResponse?.data?.message, "warning", true, "Advertencias");
            }
        }

    },[state.formResponse])

    function openModalTerms() {
        setModalInfo({titleModal:"Información",msgModal:state?.webContentTextTerms,status:"info"});
        setVisibleModal(true);
    }

    React.useEffect(() => {
        if(optionsRegion.length > 1) {

            const regionName = optionsRegion.filter(obj => {
                return Number(obj.value) === Number(form.region);
            });

            const comunaName = optionsComunaRegion.filter(obj => {
                return Number(obj.value) === Number(form.comuna);
            });

            setForm({...form,regionName:regionName[0]?.label,comunaName:comunaName[0]?.label });
        }

    },[optionsRegion]);

    function checkPasswordFunc(password){
        let checkPass = {}
        let m;
        if( !(m = password.match(/[a-z]/g))){
            checkPass.lowerCase = false
        } else {
            checkPass.lowerCase = true
        }

        if( !(m = password.match(/[A-Z]/g))){
            checkPass.upperCase = false
        } else {
            checkPass.upperCase = true
        }

        if( !(m = password.match(/[0-9]/g))){
            checkPass.containsNumber = false
        } else {
            checkPass.containsNumber = true
        }

        if(password.length < 8){
            checkPass.minLength = false
        } else {
            checkPass.minLength = true
        }

        setCheckPassword(checkPass)
        return checkPass
    }

    React.useEffect(() => {
        if(form?.password){
            checkPasswordFunc(form?.password);
        }
    },[form?.password])

    return (
        <>
            <CGE.Panel title={decode_utf8(props?.title_second_page_user_register)} description={props?.description_second_page_user_register}>
                <CGE.PanelSection title={decode_utf8(props.subtitle1_second_page_user_register)}>
                    <div className="row">
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,name:e.target.value })}
                                idFormElement="inputName"
                                mandatoryElement={true}
                                typeElement="input"
                                typeFormElement="text"
                                labelName="Nombres:"
                                placeholder="Nombres"
                                hasError={validForm?.validateName}
                                msgError={validForm?.msgName && validForm?.validateName?validForm?.msgName:""}
                                value={form?.name}
                                maxLength={100}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,firstName:e.target.value })}
                                idFormElement="inputFirstName"
                                mandatoryElement={true}
                                typeElement="input"
                                typeFormElement="text"
                                labelName="Primer Apellido:"
                                placeholder="Primer Apellido"
                                hasError={validForm?.validateFirstName}
                                msgError={validForm?.msgFirstName && validForm?.validateFirstName?validForm?.msgFirstName:""}
                                value={form?.firstName}
                                maxLength={100}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,secondName:e.target.value })}
                                idFormElement="inputSecondName"
                                mandatoryElement={true}
                                typeElement="input"
                                typeFormElement="text"
                                labelName="Segundo Apellido:"
                                placeholder="Segundo Apellido"
                                hasError={validForm?.validateSecondName}
                                msgError={validForm?.msgSecondName && validForm?.validateSecondName?validForm?.msgSecondName:""}
                                value={form?.secondName}
                                maxLength={100}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,cel:e.target.value })}
                                idFormElement="inputCel"
                                mandatoryElement={true}
                                typeElement="input-mask"
                                typeFormElement="text"
                                labelName="Celular:"
                                placeholder="Celular"
                                hasError={validForm?.validateCel}
                                msgError={validForm?.msgCel && validForm?.validateCel?validForm?.msgCel:""}
                                value={form?.cel}
                                formatChars={{
                                    9: "[0-9]"
                                }}
                                mask="999999999"
                                inputExemple="* Ejemplo: 912376129"
                            />
                        </div>
                        <div className="col-md-1">
                            <CGE.FormsField
                                handleChange={(e) => setForm({ ...form, prefixCell: e.target.value })}
                                idFormElement="prefixCell"
                                labelName="Teléfono:"
                                typeElement="select"
                                value={form.prefixCell}
                                listOptions={optionsPrefixCell}

                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,tel:e.target.value })}
                                idFormElement="inputTel"
                                typeElement="input-mask"
                                typeFormElement="text"
                                style={{ marginTop: '40px'}}
                                placeholder="Telefono"
                                hasError={validForm?.validateTel}
                                msgError={validForm?.msgTel && validForm?.validateTel?validForm?.msgTel:""}
                                value={form?.tel}
                                formatChars={{
                                    9: "[0-9]"
                                }}
                                mask="99999999"
                                inputExemple="* Ejemplo: 68007001"
                            />
                        </div>
                        <div className="col-md-4">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,email:e.target.value })}
                                idFormElement="inputEmail"
                                mandatoryElement={true}
                                typeElement="input"
                                typeFormElement="text"
                                labelName="E-mail:"
                                placeholder="E-mail"
                                hasError={validForm?.validateEmail}
                                msgError={validForm?.msgEmail && validForm?.validateEmail?validForm?.msgEmail:""}
                                value={form?.email}
                            />
                        </div>
                        <div className="col-md-4">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,emailConf:e.target.value })}
                                idFormElement="inputEmailConf"
                                mandatoryElement={true}
                                typeElement="input"
                                typeFormElement="text"
                                labelName="Confirma tu E-mail:"
                                placeholder="Confirma tu E-mail"
                                hasError={validForm?.validateEmailConf}
                                msgError={validForm?.msgEmailConf && validForm?.validateEmailConf?validForm?.msgEmailConf:""}
                                value={form?.emailConf}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>

                <CGE.PanelSection title={decode_utf8(props?.subtitle2_second_page_user_register)}>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,address:e.target.value })}
                                idFormElement="inputAddress"
                                mandatoryElement={true}
                                typeElement="input"
                                typeFormElement="text"
                                labelName="Dirección:"
                                placeholder="Dirección"
                                hasError={validForm?.validateAddress}
                                msgError={validForm?.msgAddress && validForm?.validateAddress?validForm?.msgAddress:""}
                                value={form?.address}
                                maxLength={200}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,addressNumber:e.target.value })}
                                idFormElement="inputAddressNumber"
                                mandatoryElement={true}
                                typeElement="input"
                                typeFormElement="text"
                                labelName="Nro:"
                                placeholder="Nro"
                                hasError={validForm?.validateAddressNumber}
                                msgError={validForm?.msgAddressNumber && validForm?.validateAddressNumber?validForm?.msgAddressNumber:""}
                                value={form?.addressNumber}
                                maxLength={10}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,addressApt:e.target.value })}
                                idFormElement="inputAddressApt"
                                typeElement="input"
                                typeFormElement="text"
                                labelName="Dpto:"
                                placeholder="Dpto"
                                hasError={validForm?.validateAddressApt}
                                msgError={validForm?.msgAddressApt && validForm?.validateAddressApt?validForm?.msgAddressApt:""}
                                value={form?.addressApt}
                                maxLength={10}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,region:e.target.value })}
                                idFormElement="inputRegion"
                                mandatoryElement={true}
                                labelName="Región:"
                                typeElement="select"
                                hasError={validForm?.validateRegion}
                                msgError={validForm?.msgRegion && validForm?.validateRegion?validForm?.msgRegion:""}
                                value={form?.region}
                                listOptions={optionsRegion?optionsRegion:[]}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,comuna:e.target.value })}
                                idFormElement="inputComuna"
                                mandatoryElement={true}
                                labelName="Comuna:"
                                typeElement="select"
                                hasError={validForm?.validateComuna}
                                msgError={validForm?.msgComuna && validForm?.validateComuna?validForm?.msgComuna:""}
                                value={form?.comuna}
                                listOptions={optionsComunaRegion?optionsComunaRegion:[]}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>

                <CGE.PanelSection title={decode_utf8(props?.subtitle3_second_page_user_register)}>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => {
                                    setForm({...form,password:e.target.value });
                                }}
                                idFormElement="inputPassword"
                                mandatoryElement={true}
                                typeElement="input"
                                style={{ "-webkit-text-security" : "disc" }}
                                typeFormElement="text"
                                labelName="Contraseña de acceso:"
                                placeholder="Contraseña"
                                hasError={validForm?.validatePassword}
                                msgError={validForm?.msgPassword && validForm?.validatePassword?validForm?.msgPassword:""}
                                value={form?.password}
                                inputExemple="* Debe contener como minimo 8 caracteres y le sugerimos no utilizar palabras conocidas."
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,passwordConf:e.target.value })}
                                idFormElement="inputPasswordConf"
                                mandatoryElement={true}
                                typeElement="input"
                                style={{ "-webkit-text-security" : "disc" }}
                                typeFormElement="text"
                                labelName="Confirma tu contraseña:"
                                placeholder="Confirma tu Contraseña"
                                hasError={validForm?.validatePasswordConf}
                                msgError={validForm?.msgPasswordConf && validForm?.validatePasswordConf?validForm?.msgPasswordConf:""}
                                value={form?.passwordConf}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection>
                    <div className="d-flex flex-column">
                        <CGE.FieldCheckPassowd
                            checked={checkPassword?.lowerCase}
                            labelName={props.condition_cambio_contrasena_1}
                        />
                        <CGE.FieldCheckPassowd
                            checked={checkPassword?.upperCase}
                            labelName={props.condition_cambio_contrasena_2}
                        />
                        <CGE.FieldCheckPassowd
                            checked={checkPassword?.containsNumber}
                            labelName={props.condition_cambio_contrasena_3}
                        />
                        <CGE.FieldCheckPassowd
                            checked={checkPassword?.minLength}
                            labelName={props.condition_cambio_contrasena_4}
                        />
                    </div>

                </CGE.PanelSection>
                <CGE.FormsField
                    checked={valueCheckBoxSubscription}
                    labelName="Acepto los Terminos y condiciones del uso del sitio"
                    handleChange={() => setValueCheckBoxSubscription((val) => !val)}
                    idFormElement="inputCheckBoxSubscription"
                    typeFormElement="checkbox"
                    mandatoryElement={false}
                    typeElement="input"
                    className="mb-0"
                />
                <a onClick={() => openModalTerms()} >Ver Terminos y Condiciones</a>
                <CGE.Spacing type="nl" />
                <CGE.FieldRecaptcha
                    onChange={onChangeReCaptcha}
                    sitekey={props.api_key_recaptcha}
                />
                <CGE.Spacing type="nl" />
                <div className='col-md-12 pt-2 d-flex justify-content-between'>
                    <CGE.Button
                        size="sm"
                        label="Cancelar"
                        type="secondary"
                        href="/"
                    />
                    <CGE.Button
                        size="sm"
                        label="Enviar"
                        onClick={() => handleClickSecondPage()}
                    />
                </div>
            </CGE.Panel>
            {visibleModal && !loading && (
                <AlertModal
                    titleModal={modalInfo?.titleModal}
                    msgModal={modalInfo?.msgModal}
                    observer={observer}
                    onClose={onClose}
                    status={modalInfo?.status}
                />
            )}
            {visibleModalConfirm && (
                <AlertModal
                    titleModal="Información"
                    observer={observer}
                    onClose={onClose}
                    msgModal={"<b>Ya existe una cuenta con estos datos. <br />¿Quieres proceder a recuperar la contraseña?</b>"}
                    status="info"
                    funcClick={() => {
                        window.open(`/web/guest/recuperacion-de-contrasena?rut=`+form?.rut, '_self');
                        onClose();
                    }}
                    labelBtnCancel={"No"}
                    btnCancel={true}
                    labelBtnConfirm={"Si"}
                    confirm={true}
                />
            )}
            {loading && <Loading />}
        </>
    );
};

export default PersonalInfo;